import { ProjectType } from '@prisma/client';

export const SEAGRASS_PROJECT_ID = 11129;
export const WILDFLOWERS_PROJECT_ID = 4826;
export const PEATLANDS_PROJECT_ID = 11169;

export const projectIdRestorationMapper: Record<number, ProjectType> = {
  [SEAGRASS_PROJECT_ID]: ProjectType.SEAGRASS,
  [WILDFLOWERS_PROJECT_ID]: ProjectType.WILDFLOWERS,
  [PEATLANDS_PROJECT_ID]: ProjectType.PEATLANDS,
};

export const API_DEFAULT_HABITAT_RESTORATION_PROJECT_ID = WILDFLOWERS_PROJECT_ID;
